const t = {
  name: "Plant",
  dimensions: { width: 22, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4663)">
    <path d="M16.051 10.0029C14.491 10.0029 13.071 10.6029 12.001 11.5729V8.00293V6.06293C12.001 2.72293 9.28098 0.00292969 5.94098 0.00292969H0.000976562V5.95293C0.000976562 9.28293 2.72098 12.0029 6.05098 12.0029H10.001V16.0529V22.0029V26.0029H3.50098C3.20098 26.0029 2.91098 26.1429 2.72098 26.3729C2.53098 26.6029 2.46098 26.9129 2.52098 27.2029L5.02098 39.2029C5.12098 39.6729 5.53098 40.0029 6.00098 40.0029H16.001C16.471 40.0029 16.881 39.6729 16.981 39.2029L19.481 27.2029C19.541 26.9129 19.471 26.6029 19.281 26.3729C19.091 26.1429 18.801 26.0029 18.501 26.0029H12.001V22.0029H15.941C19.281 22.0029 22.001 19.2829 22.001 15.9429V10.0029H16.051ZM15.191 38.0029H9.12098C7.78098 38.0029 6.62098 37.0629 6.34098 35.7429L5.56098 32.0029H16.431L15.191 38.0029ZM16.851 30.0029H5.15098L4.73098 28.0029H15.231C16.281 28.0029 17.071 28.9729 16.851 30.0029ZM6.05098 10.0029C3.82098 10.0029 2.00098 8.18293 2.00098 5.95293V2.00293H5.94098C8.18098 2.00293 10.001 3.82293 10.001 6.06293V8.00293V10.0029H6.05098ZM20.001 15.9429C20.001 18.1829 18.181 20.0029 15.941 20.0029H12.001V16.0529C12.001 13.8129 13.821 12.0029 16.051 12.0029H20.001V15.9429Z"/>
    </g>
    <defs>
    <clipPath id="clip0_12_4663">
    <rect width="22" height="40" fill="currentColor" transform="translate(0.000976562 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  t as Plant
};
